import directus from '@/plugins/directusSdk'
import errorDirectus from '@/lib/Error/directus'

export default {
  async getItems ({ commit, dispatch }) {
    try {
      const { data } = await directus.getItems('member_seating_status', {
        fields: [
          '*',
          'user.first_name',
          'user.last_name',
          'user.avatar.*',
          'now.value'
        ]
      })
      commit('setAttr', {
        name: 'models',
        value: data
      })
    } catch (err) {
      errorDirectus(err, dispatch)
    }
  }
}
